// ============================================================================
// MAIN ENTRY POINT
// ============================================================================

import { Game } from './game.js';

// Start game when page loads
window.addEventListener('load', () => {
    // Load game from Tiled map
    // Use relative paths from index.html location (no leading dot or slash)
    // In dev: index.html is in src/, assets are in src/assets/, so 'assets/map2.json' works
    // In build: index.html and assets/ are at same level, so 'assets/map2.json' works
    // Both use the same relative path!
    const mapPaths = ['assets/map2.json'];
    
    const tryLoadMap = async (index = 0) => {
        if (index >= mapPaths.length) {
            // All paths failed
            console.error('Failed to load map from all attempted paths:', mapPaths);
            const canvas = document.getElementById('gameCanvas');
            if (canvas) {
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#000';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = '#ff0000';
                ctx.font = '24px Arial';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText('Error: Failed to load map file', canvas.width / 2, canvas.height / 2 - 20);
                ctx.fillText('Tried: ' + mapPaths.join(', '), canvas.width / 2, canvas.height / 2 + 20);
            }
            return;
        }
        
        const mapPath = mapPaths[index];
        console.log(`Attempting to load map from: ${mapPath} (attempt ${index + 1}/${mapPaths.length})`);
        
        try {
            const game = await Game.loadFromTiled(mapPath);
            console.log('Game loaded successfully from:', mapPath);
            // Game is already running
        } catch (error) {
            console.warn(`Failed to load from ${mapPath}, trying next path...`, error.message);
            tryLoadMap(index + 1);
        }
    };
    
    tryLoadMap();
});
